import { render } from "./FriendPage.vue?vue&type=template&id=bb12c54c&ts=true"
import script from "./FriendPage.vue?vue&type=script&lang=ts"
export * from "./FriendPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__